<label class="field" [attr.for]="inputId">
  <span class="field-label">{{ label }} <strong *ngIf="required" aria-hidden="true">*</strong></span>
  <ion-input
    [id]="inputId"
    [type]="type"
    [value]="value"
    [placeholder]="placeholder"
    [maxlength]="maxLength"
    [autocomplete]="autocomplete"
    [disabled]="disabled"
    [required]="required"
    [attr.aria-label]="label"
    [attr.aria-invalid]="errorText ? 'true' : null"
    [attr.aria-describedby]="errorText ? inputId + '-error' : null"
    (ionInput)="onInput($event)"
    (ionBlur)="onBlur()">
  </ion-input>
  <small *ngIf="errorText" [id]="inputId + '-error'" class="field-error">{{ errorText }}</small>
</label>